import React from 'react';

import Image from 'marketing-website/components/modules/Image';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import MarvelLink from '@marvelapp/marvel-ui/link';

import Page from 'marketing-website/components/modules/Page';
import Whitespace from 'marketing-website/components/commons/Whitespace';

import assets from 'marketing-website/configs/pages/pop/assets.js';

import Record from './Record';
import Web from './Web';
import Sketching from './Sketching';
import Devices from './Devices';
import Share from './Share';
import Trust from './Trust';

import styles from './style/general.module.css';

export default function Pop() {
  return (
    <Page
      title="POP by Marvel - Turn sketches into iOS and Android prototypes"
      meta={[
        {
          name: 'description',
          content:
            'Transform your design sketches into interactive prototypes for iPhone, iPad, Apple Watch, Apple TV and Android devices with POP by Marvel.',
        },
        {
          name: 'keywords',
          content:
            'prototype, prototyping, mockups, app prototype, product design',
        },
      ]}
      banner
      header
      footer
    >
      <div className="overflow-hidden">
        <div className={styles.wrap}>
          <Spacing size="l" type="padding" position="bottom">
            <Image {...assets.logo} />
          </Spacing>
          <h1 className={styles.heading}>Prototyping on paper</h1>
          <Spacing size="l" type="padding" position="bottom">
            <MaxWidth value={720}>
              <p className={styles.subheading}>
                POP helps you transform your pen and paper ideas into an
                interactive iPhone or Android prototype.
              </p>
            </MaxWidth>
          </Spacing>
          <div className={styles.buttons}>
            <div className={styles.margin}>
              <MarvelLink
                url="https://itunes.apple.com/us/app/pop-prototyping-on-paper/id555647796?mt=8"
                target="_blank"
              >
                <Image {...assets.appStore} />
              </MarvelLink>
            </div>
            <div>
              <MarvelLink
                url="https://play.google.com/store/apps/details?id=com.marvelapp"
                target="_blank"
              >
                <Image {...assets.googlePlay} />
              </MarvelLink>
            </div>
          </div>
        </div>
        <Sketching />
        <Devices />
        <Whitespace size="l" />
        <Record />
        <Whitespace size="xl" />
        <Web />
        <Trust />
        <Share />
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pop/index.js